
{
  "familyId": "SPR-WEET-EI-IJ",
  "questions": [
    {
      "id": "SPR-WEET-EI-IJ-001",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "multiple_choice",
      "question": "Een leerling schrijft in zijn verhaal: 'De trijn rijdt naar het station.' De juf zet een streep onder één woord. Welke verbetering is correct?",
      "context": "De leerling twijfelt of het woord met 'ei' of 'ij' geschreven wordt.",
      "options": ["trein (met ei)", "trijn (met ij) — het is al goed", "trien (met ie)", "trèin (met è)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "EI of IJ?",
            "content": "'Trein' schrijf je met 'ei'. Dit is een weetwoord — je moet het uit je hoofd leren. Andere woorden met ei: klein, leiden, meisje, reis.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_trein",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Trein' schrijf je met 'ei'. Dit is een weetwoord dat je uit je hoofd moet leren. De ei en ij klinken hetzelfde, maar je schrijft ze anders. Onthoud: trein, klein, reis, meisje — allemaal met 'ei'.",
        "solutionSteps": [
          "Klinkt het als 'ei' of 'ij'? → Beide klinken hetzelfde!",
          "'Trein' is een weetwoord → uit je hoofd leren",
          "Het wordt geschreven met 'ei'",
          "Ezelsbruggetje: trein, klein, reis, meisje = ei-woorden"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Trein' schrijf je met ei. Dit is een weetwoord.",
          "1": "Je dacht waarschijnlijk dat 'trein' met 'ij' geschreven wordt. Maar 'trijn' bestaat niet als woord. 'Trein' is een weetwoord met 'ei'. Onthoud: je moet ei/ij-woorden uit je hoofd leren, want ze klinken hetzelfde.",
          "2": "Je dacht waarschijnlijk dat de klank 'ie' is. Maar de klank in 'trein' is 'ei' (of 'ij'), niet 'ie'. 'Ie' klinkt anders: denk aan 'brief' of 'dier'. Onthoud: luister goed naar de klank.",
          "3": "Je dacht waarschijnlijk dat er een accent op de 'e' staat. Maar in het Nederlands gebruiken we geen accent grave (è) in gewone woorden. De juiste spelling is 'trein' met 'ei'."
        }
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-002",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist?",
      "context": null,
      "options": ["bijzonder", "beizonder", "bijsonder", "beisonder"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "IJ of EI?",
            "content": "'Bijzonder' schrijf je met 'ij'. Dit is een weetwoord. Tip: 'bij' is een voorvoegsel dat altijd met 'ij' geschreven wordt (bijv. bijzonder, bijvoorbeeld, bijdrage).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_bijzonder",
      "variantIndex": 2,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Bijzonder' schrijf je met 'ij'. Het voorvoegsel 'bij-' wordt altijd met 'ij' geschreven. Andere voorbeelden: bijvoorbeeld, bijdrage, bijzin. Onthoud: als een woord begint met 'bij-', is het altijd 'ij'.",
        "solutionSteps": [
          "Herken het voorvoegsel: 'bij-' + 'zonder'",
          "Het voorvoegsel 'bij-' schrijf je altijd met 'ij'",
          "De rest van het woord: 'zonder' met een 'z'",
          "Dus: bijzonder (met ij en z)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Bijzonder' met ij. Het voorvoegsel 'bij-' is altijd met 'ij'.",
          "1": "Je dacht waarschijnlijk dat het voorvoegsel 'bei-' is (met ei). Maar het voorvoegsel is 'bij-' (met ij). Onthoud: bij-, bijv., bijdrage — altijd met 'ij'. Het helpt om het woordje 'bij' (het insect) te onthouden.",
          "2": "Je dacht waarschijnlijk dat 'zonder' met een 's' geschreven wordt. Maar 'zonder' begint met een 'z'. De juiste spelling is 'bijzonder'. Onthoud: luister goed — 'z' klinkt zachter dan 's'.",
          "3": "Je dacht waarschijnlijk dat het 'bei-' is én 'sonder' met een 's'. Maar beide zijn fout: het voorvoegsel is 'bij-' (met ij) en 'zonder' begint met een 'z'. Onthoud: bijzonder = bij + zonder."
        }
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-003",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist?",
      "context": null,
      "options": ["eigenlijk", "ijgenlijk", "eigenlek", "ijgenlek"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "EI of IJ?",
            "content": "'Eigenlijk' schrijf je met 'ei'. Dit is een weetwoord. Tip: 'eigen' begint altijd met 'ei' (bijv. eigenaar, eigendom, eigenlijk).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_eigenlijk",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Eigenlijk' schrijf je met 'ei'. Het woord 'eigen' begint altijd met 'ei'. Andere voorbeelden: eigenaar, eigendom, eigenwijs. Onthoud: als een woord begint met 'eigen-', is het altijd 'ei'.",
        "solutionSteps": [
          "Herken het basiswoord: 'eigen' + '-lijk'",
          "'Eigen' begint altijd met 'ei'",
          "Het achtervoegsel is '-lijk' (niet '-lek')",
          "Dus: eigenlijk (met ei en -lijk)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Eigenlijk' met ei. Het woord 'eigen' begint altijd met 'ei'.",
          "1": "Je dacht waarschijnlijk dat 'eigen' met 'ij' begint. Maar 'eigen' schrijf je altijd met 'ei'. Onthoud: eigenaar, eigendom, eigenlijk — allemaal met 'ei'. Het helpt om het woord 'ei' (van een kip) te onthouden.",
          "2": "Je dacht waarschijnlijk dat het achtervoegsel '-lek' is. Maar het achtervoegsel is '-lijk' (zoals in 'eerlijk', 'duidelijk', 'eigenlijk'). Onthoud: '-lijk' is een veelvoorkomend achtervoegsel in het Nederlands.",
          "3": "Je dacht waarschijnlijk dat het 'ij' is én '-lek'. Maar beide zijn fout: 'eigen' begint met 'ei' en het achtervoegsel is '-lijk'. Onthoud: eigenlijk = eigen + lijk."
        }
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-004",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "fill_in",
      "question": "Schrijf het woord correct: b_zonder (met ei of ij). Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["bijzonder"],
        "caseSensitive": false,
        "placeholder": "b...zonder"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voorvoegsel bij-",
            "content": "Het voorvoegsel 'bij-' schrijf je altijd met 'ij': bijzonder, bijvoorbeeld, bijdrage.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_fill_bij",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Bijzonder' schrijf je met 'ij'. Het voorvoegsel 'bij-' wordt altijd met 'ij' geschreven. Andere voorbeelden: bijvoorbeeld, bijdrage, bijzin. Onthoud: bij = altijd ij.",
        "solutionSteps": [
          "Herken het voorvoegsel: 'bij-'",
          "'Bij-' schrijf je altijd met ij",
          "De rest: 'zonder' (met z)",
          "Dus: bijzonder"
        ]
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-005",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "fill_in",
      "question": "Schrijf het woord correct: _genlijk (met ei of ij). Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["eigenlijk"],
        "caseSensitive": false,
        "placeholder": "...genlijk"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eigen met ei",
            "content": "'Eigen' begint altijd met 'ei': eigenaar, eigendom, eigenlijk.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_fill_eigen",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Eigenlijk' schrijf je met 'ei'. Het woord 'eigen' begint altijd met 'ei'. Andere voorbeelden: eigenaar, eigendom, eigenwijs. Onthoud: eigen = altijd ei.",
        "solutionSteps": [
          "Het woord begint met 'eigen'",
          "'Eigen' schrijf je altijd met ei",
          "Achtervoegsel: '-lijk'",
          "Dus: eigenlijk"
        ]
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-006",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "fill_in",
      "question": "Schrijf het woord correct: vr_heid (met ei of ij). Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["vrijheid"],
        "caseSensitive": false,
        "placeholder": "vr...heid"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vrij met ij",
            "content": "'Vrij' schrijf je altijd met 'ij': vrijheid, vrijdag, bevrijding.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_fill_vrij",
      "variantIndex": 6,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Vrijheid' schrijf je met 'ij'. Het woord 'vrij' wordt altijd met 'ij' geschreven. Andere voorbeelden: vrijdag, bevrijding, vrijwillig. Onthoud: vrij = altijd ij.",
        "solutionSteps": [
          "Het woord bevat 'vrij'",
          "'Vrij' schrijf je altijd met ij",
          "Achtervoegsel: '-heid'",
          "Dus: vrijheid"
        ]
      }
    }
  ]
}
